import React from 'react';
import './SocialLinks.css';

interface SocialLinksProps {
  social: {
    github?: string;
    linkedin?: string;
    researchgate?: string;
    scholar?: string;
    orcid?: string;
    twitter?: string;
    [key: string]: string | undefined;
  };
}

const SocialLinks: React.FC<SocialLinksProps> = ({ social }) => {
  const getIcon = (platform: string): string => {
    switch (platform) {
      case 'github': return '🐙';
      case 'linkedin': return '💼';
      case 'researchgate': return '🔬';
      case 'scholar': return '🎓';
      case 'orcid': return '🆔';
      case 'twitter': return '🐦';
      default: return '🔗';
    }
  };

  const getLabel = (platform: string): string => {
    switch (platform) {
      case 'github': return 'GitHub';
      case 'linkedin': return 'LinkedIn';
      case 'researchgate': return 'ResearchGate';
      case 'scholar': return 'Google Scholar';
      case 'orcid': return 'ORCID';
      case 'twitter': return 'Twitter';
      default: return platform;
    }
  };

  return (
    <div className="social-links">
      {Object.entries(social).map(([platform, url]) => {
        if (!url) return null;
        
        return (
          <a
            key={platform}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
            title={`Visit my ${getLabel(platform)} profile`}
            aria-label={`Visit my ${getLabel(platform)} profile`}
          >
            <span className="social-icon">{getIcon(platform)}</span>
            <span className="social-label">{getLabel(platform)}</span>
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
